export var EventType;
(function (EventType) {
    EventType["globalSearchChange"] = "ksys-global-search-change";
    EventType["globalInputsChange"] = "ksys-global-inputs-change";
    EventType["appInitialized"] = "ksys-app-initialized";
    EventType["paginationChange"] = "ksys-on-pagination-change";
    EventType["updatePagination"] = "ksys-update-pagination";
    EventType["changeAttestation"] = "ksys-change-attestation";
    EventType["applyFilters"] = "ksys-apply-filters";
})(EventType || (EventType = {}));
//# sourceMappingURL=EventType.js.map